<template>
  <div class="">

    <div class="d-flex gap-10">
      <div class="file-action-btn gap-10" :class="{'active': this.resultPage.activeToolGroup === 'all'}" @click="setActiveGroup('all')" ><i class="far fa-border-all lh-inherit"></i> {{ 'All' | trans }}</div>
      <div class="file-action-btn gap-10" :class="{'active': this.resultPage.activeToolGroup === 'tools'}" @click="setActiveGroup('tools')"><i class="fa  fa-folder-open lh-inherit"></i> {{ 'Tools' | trans }}</div>
      <div class="file-action-btn gap-10" :class="{'active': this.resultPage.activeToolGroup === 'converter'}" @click="setActiveGroup('converter')"><i class="far fa-file lh-inherit"></i> {{ 'Converter' | trans }}</div>

    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import DownloadSelectedBtn from "../Elements/DownloadSelectedBtn.vue";
import PreviewManager from "../../manager/PreviewManager";
import JobManager from "../../manager/JobManager";
import OutputSelectionManager from "../../manager/OutputSelectionManager";

export default {
  name: "ToolsNav",
  props: {},
  components: {DownloadSelectedBtn},
  mixins: [
    currentJob,
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    setActiveGroup(group) {
      this.resultPage.activeToolGroup = group;
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.download-btn-main {
  padding: 0 20px;
}
.download-btn-dropdown {
  border-left: 2px solid #1158cd;
  height: 100%;
  align-items: center;
  display: inline-flex;
  padding: 0 30px;
}
.download-btn {
  padding: 0;
  background: #1266F1;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  cursor: pointer;

  &:hover {
    background: #1161e5;
  }
}

.file-action-btn {
  cursor: pointer;
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  display:flex;
  align-items:center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;

  &.active {
    background: #1266F1;
    color: white;
  }

  .dark-mode & {
    background:#383838;;
    border: 1px solid #595959;
    color: white;
    &:hover {
      background: #323232;
    }
  }
}
</style>
